export default {
    url: '/validations',
    template: '<ui-view></ui-view>',
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canManageValidations();
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/validations/index.js